<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
	import util from '@/libs/util'
	export default {
		name: 'app',
		watch: {
			'$i18n.locale': 'i18nHandle'
		},
		created() {
			this.i18nHandle(this.$i18n.locale)
			this.autoWsLogin() //检查ws连接状态，刷新后ws会断，判断之前是否是登陆的，是就重新连接
			window.addEventListener("beforeunload", this.handleBeforeUnload) //增加 页面关闭阻止的监听
		},
		mounted() {
			this.autoGetWinHeight() //自动获取浏览器高度
			
		},
		beforeDestroy() {
			window.removeEventListener("beforeunload", this.handleBeforeUnload) //移除 页面关闭阻止的监听
		},
		methods: {
			i18nHandle(val, oldVal) {
				util.cookies.set('lang', val)
				document.querySelector('html').setAttribute('lang', val)
			},
			//自动获取浏览器高度，很多容器需要它设置合适高度---
			autoGetWinHeight() {
				//获取当前浏览器高度
				this.$store.commit('d2admin/mystore/setWinHeight', window.innerHeight)
				//给浏览器变动事件添加更新功能
				window.onresize = this._.debounce(() => {
					return (() => {
						this.$store.commit('d2admin/mystore/setWinHeight', window.innerHeight)
					})()
				}, 200)
			},
			//检查ws连接状态，刷新后ws会断，判断之前是否是登陆的，是就重新连接
			autoWsLogin() {
				let sup = this.$util.cookies.get('WsSupport')
				let state = this.$util.cookies.get('WsLoginState')
				if (sup && state) {
					this.$ws.wsConnect()
				}
			},
			//页面关闭阻止的监听事件
			handleBeforeUnload(event) {
				if (process.env.NODE_ENV != 'development') {
					event.returnValue = "你确定要离开这个页面吗?"
				}
			},
		},



	}
</script>

<style lang="scss" scoped>
	@import '~@/assets/style/public-class.scss';
	@import '~@/assets/vxe-table/style.css'; //调整表格的滚动条
	@import '~@/assets/elementui/style.css'; //调整el的滚动条
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/App.vue"
}
</vue-filename-injector>
